import React, { useState } from "react";
import JobTypeListing from "../listing";
import BucketFilters from "./filters";
import { TypeStatsSection } from "../components/type-stats-section";

export default function BucketJobs() {

  const [filters,setFilters]=useState({})
  

  return (
    <JobTypeListing 
      type="bucket" 
      title="Bucket Jobs" 
      filters={BucketFilters}
     onFiltersChange={setFilters}
      renderContent={() => (
        <TypeStatsSection jobType="bucket" filters={filters} />
      )}
    />
  );
}
